var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import styles from './_sds-tag-base.lit.scss';
const availableSizes = ['lg', 'md', 'sm'];
/**
 * Base class for tag components that provides common functionality and properties.
 * This abstract class serves as the foundation for both standard tags and tag dropdowns.
 *
 * @abstract
 */
let SdsTagBase = (() => {
    var _a, _SdsTagBase_name_accessor_storage, _SdsTagBase_lines_accessor_storage, _SdsTagBase_status_accessor_storage, _SdsTagBase_selected_accessor_storage, _SdsTagBase_selectable_accessor_storage, _SdsTagBase_clickable_accessor_storage, _SdsTagBase_disabled_accessor_storage, _SdsTagBase__iconSize_accessor_storage, _SdsTagBase__tag_accessor_storage;
    let _classSuper = LitElement;
    let _instanceExtraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _lines_decorators;
    let _lines_initializers = [];
    let _lines_extraInitializers = [];
    let _status_decorators;
    let _status_initializers = [];
    let _status_extraInitializers = [];
    let _selected_decorators;
    let _selected_initializers = [];
    let _selected_extraInitializers = [];
    let _selectable_decorators;
    let _selectable_initializers = [];
    let _selectable_extraInitializers = [];
    let _clickable_decorators;
    let _clickable_initializers = [];
    let _clickable_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let __iconSize_decorators;
    let __iconSize_initializers = [];
    let __iconSize_extraInitializers = [];
    let __tag_decorators;
    let __tag_initializers = [];
    let __tag_extraInitializers = [];
    let _set_size_decorators;
    return _a = class SdsTagBase extends _classSuper {
            /**
             * The name or text content of the tag.
             * This is displayed as the main content of the tag.
             *
             * @attr
             * @default ""
             */
            get name() { return __classPrivateFieldGet(this, _SdsTagBase_name_accessor_storage, "f"); }
            set name(value) { __classPrivateFieldSet(this, _SdsTagBase_name_accessor_storage, value, "f"); }
            /**
             * The number of lines to display in the tag.
             * Controls text truncation behavior in the tag.
             *
             * @attr
             * @default 1
             */
            get lines() { return __classPrivateFieldGet(this, _SdsTagBase_lines_accessor_storage, "f"); }
            set lines(value) { __classPrivateFieldSet(this, _SdsTagBase_lines_accessor_storage, value, "f"); }
            /**
             * The status of the tag, which determines its visual appearance.
             * Different statuses have different color schemes and visual treatments.
             *
             * @attr
             * @default "main"
             */
            get status() { return __classPrivateFieldGet(this, _SdsTagBase_status_accessor_storage, "f"); }
            set status(value) { __classPrivateFieldSet(this, _SdsTagBase_status_accessor_storage, value, "f"); }
            /**
             * Whether the tag is in a selected state.
             * When true, the tag will display a selected visual state.
             *
             * @attr
             * @default false
             */
            get selected() { return __classPrivateFieldGet(this, _SdsTagBase_selected_accessor_storage, "f"); }
            set selected(value) { __classPrivateFieldSet(this, _SdsTagBase_selected_accessor_storage, value, "f"); }
            /**
             * Whether the tag can be selected by clicking.
             * When true, clicking the tag will toggle its selected state.
             *
             * @attr
             * @default false
             */
            get selectable() { return __classPrivateFieldGet(this, _SdsTagBase_selectable_accessor_storage, "f"); }
            set selectable(value) { __classPrivateFieldSet(this, _SdsTagBase_selectable_accessor_storage, value, "f"); }
            /**
             * Whether the tag can be selected by clicking.
             * When true, clicking the tag will toggle its selected state.
             *
             * @attr
             * @default false
             */
            get clickable() { return __classPrivateFieldGet(this, _SdsTagBase_clickable_accessor_storage, "f"); }
            set clickable(value) { __classPrivateFieldSet(this, _SdsTagBase_clickable_accessor_storage, value, "f"); }
            /**
             * Whether the tag is disabled.
             * When true, the tag cannot be interacted with and displays a disabled visual state.
             *
             * @attr
             * @default false
             */
            get disabled() { return __classPrivateFieldGet(this, _SdsTagBase_disabled_accessor_storage, "f"); }
            set disabled(value) { __classPrivateFieldSet(this, _SdsTagBase_disabled_accessor_storage, value, "f"); }
            /**
             * The size of the icon used in the tag dropdown.
             * This is automatically set based on the tag size.
             *
             * @internal
             * @default 24
             */
            get _iconSize() { return __classPrivateFieldGet(this, _SdsTagBase__iconSize_accessor_storage, "f"); }
            set _iconSize(value) { __classPrivateFieldSet(this, _SdsTagBase__iconSize_accessor_storage, value, "f"); }
            /** Reference to the underlying tag element */
            get _tag() { return __classPrivateFieldGet(this, _SdsTagBase__tag_accessor_storage, "f"); }
            set _tag(value) { __classPrivateFieldSet(this, _SdsTagBase__tag_accessor_storage, value, "f"); }
            /**
             * Creates a new instance of the SdsTagBase class.
             * Initializes the tag and sets up event listeners.
             */
            constructor() {
                super();
                _SdsTagBase_name_accessor_storage.set(this, (__runInitializers(this, _instanceExtraInitializers), __runInitializers(this, _name_initializers, void 0)));
                _SdsTagBase_lines_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _lines_initializers, void 0)));
                _SdsTagBase_status_accessor_storage.set(this, (__runInitializers(this, _lines_extraInitializers), __runInitializers(this, _status_initializers, 'default')));
                _SdsTagBase_selected_accessor_storage.set(this, (__runInitializers(this, _status_extraInitializers), __runInitializers(this, _selected_initializers, false)));
                _SdsTagBase_selectable_accessor_storage.set(this, (__runInitializers(this, _selected_extraInitializers), __runInitializers(this, _selectable_initializers, false)));
                _SdsTagBase_clickable_accessor_storage.set(this, (__runInitializers(this, _selectable_extraInitializers), __runInitializers(this, _clickable_initializers, false)));
                _SdsTagBase_disabled_accessor_storage.set(this, (__runInitializers(this, _clickable_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
                _SdsTagBase__iconSize_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, __iconSize_initializers, 24)));
                /**
                 * The size of the tag.
                 * This is a protected property that is accessed through the size getter/setter.
                 *
                 * @internal
                 * @default "lg"
                 */
                this._size = (__runInitializers(this, __iconSize_extraInitializers), 'lg');
                _SdsTagBase__tag_accessor_storage.set(this, __runInitializers(this, __tag_initializers, void 0));
                /** Whether the tag is currently focused */
                this._isFocused = (__runInitializers(this, __tag_extraInitializers), false);
                /** Whether the tag was clicked (vs. focused via keyboard) */
                this._isClicked = false;
                this.disableClickWhenTagIsDisabled();
            }
            /**
             * Programmatically focuses the tag.
             * This method can be called from outside the component to set focus.
             */
            focus() {
                this._tag.focus();
                this._isFocused = true;
                this.requestUpdate();
            }
            /**
             * Gets the current size of the tag.
             *
             * @returns The current tag size
             */
            get size() {
                return this._size;
            }
            /**
             * Sets the size of the tag.
             * Validates that the provided size is one of the available sizes.
             *
             * @param value - The new size for the tag
             */
            set size(value) {
                const oldValue = this._size;
                this._size = value;
                this.requestUpdate('size', oldValue);
            }
            /**
             * Lifecycle method called before updating the component.
             * Updates the icon size based on the tag size.
             *
             * @param changedProperties - Map of properties that have changed
             */
            willUpdate(changedProperties) {
                if (changedProperties.has('size')) {
                    this._size === 'lg' ? (this._iconSize = 24) : (this._iconSize = 16);
                }
            }
            /**
             * Programmatically clicks the toggle
             * @public
             */
            click() {
                this._tag.click();
            }
            /**
             * Handles focus events on the tag.
             * Sets the focused state.
             */
            handleFocus() {
                if (!this._isClicked) {
                    this._isFocused = true;
                    this.requestUpdate();
                }
                else {
                    this._isFocused = false;
                }
            }
            /**
             * Handles blur events on the tag.
             * Clears the focused and clicked states.
             */
            handleBlur() {
                this._isFocused = false;
                this._isClicked = false;
                this.requestUpdate();
            }
            /**
             * Handles mouse down events on the tag.
             * Sets the focused state during mousedown.
             */
            handleMouseDown() {
                if (this.clickable || this.selectable) {
                    this._isFocused = false;
                    this._isClicked = true;
                    this.requestUpdate();
                }
            }
            /**
             * Handles click events on the tag.
             * If the tag is clickable, toggles the selected state and dispatches a click event.
             */
            handleClick() {
                if (this.clickable || this.selectable) {
                    this.selected = !this.selected;
                }
            }
            /**
             * Handles keyboard events on the tag.
             * Manages focus styling based on keyboard interaction.
             *
             * @param e - The keyboard event
             */
            handleKeyDown(e) {
                // Ignore modifier keys (Shift, Ctrl, Alt, Meta)
                if (e.key === 'Shift' || e.key === 'Control' || e.key === 'Alt' || e.key === 'Meta') {
                    return;
                }
                // Handle space key for selection
                if (e.key === ' ' || e.key === 'Space' || e.key === 'Spacebar') {
                    e.preventDefault();
                    this._isFocused = true;
                    this._isClicked = true;
                    this.requestUpdate();
                    this.click();
                    return;
                }
            }
            /**
             * Generates the CSS classes for the tag based on its properties.
             *
             * @returns An object mapping class names to boolean values
             */
            getClasses() {
                return classMap({
                    'sds-tag': true,
                    'sds-tag--lg': this.size === 'lg',
                    'sds-tag--md': this.size === 'md',
                    'sds-tag--sm': this.size === 'sm',
                    'sds-tag--disabled': this.disabled,
                    'sds-tag--selected': this.selected,
                    'sds-tag--clickable': this.clickable,
                    'sds-tag--selectable': this.selectable,
                    'sds-tag--focused': this._isFocused,
                    'sds-tag--default': this.status === 'default',
                    'sds-tag--success': this.status === 'success',
                    'sds-tag--warning': this.status === 'warning',
                    'sds-tag--error': this.status === 'error',
                    'sds-tag--processing': this.status === 'processing',
                    'sds-tag--done': this.status === 'done', // deprecated
                    'sds-tag--on-hold': this.status === 'on-hold', // deprecated
                    'sds-tag--overdue': this.status === 'overdue', // deprecated
                    'sds-tag--to-do': this.status === 'to-do', // deprecated
                    'sds-tag--in-progress': this.status === 'in-progress', // deprecated
                });
            }
            getAriaAttributes() {
                const statusMap = {
                    default: 'default status',
                    success: 'success status',
                    warning: 'warning status',
                    error: 'error status',
                    processing: 'processing status',
                };
                if (this.clickable) {
                    return {
                        role: 'button',
                        'aria-disabled': this.disabled ? 'true' : 'false',
                        'aria-label': `${this.name}, ${statusMap[this.status] || 'default status'}`,
                    };
                }
                if (this.selectable) {
                    return {
                        role: 'button',
                        'aria-disabled': this.disabled ? 'true' : 'false',
                        'aria-label': `${this.name}, ${statusMap[this.status] || 'default status'}${this.selected ? ', selected' : ', unselected'}`,
                    };
                }
                return {
                    role: 'status',
                    'aria-disabled': this.disabled ? 'true' : 'false',
                    'aria-label': `${this.name}, ${statusMap[this.status] || 'default status'}`,
                };
            }
            /**
             * Sets up an event listener to prevent click events when the tag is disabled.
             * This is called during initialization.
             *
             * @private
             */
            disableClickWhenTagIsDisabled() {
                this.addEventListener('click', event => {
                    if (this.disabled) {
                        event.stopImmediatePropagation();
                        event.preventDefault();
                        event.returnValue = false;
                    }
                }, true);
            }
        },
        _SdsTagBase_name_accessor_storage = new WeakMap(),
        _SdsTagBase_lines_accessor_storage = new WeakMap(),
        _SdsTagBase_status_accessor_storage = new WeakMap(),
        _SdsTagBase_selected_accessor_storage = new WeakMap(),
        _SdsTagBase_selectable_accessor_storage = new WeakMap(),
        _SdsTagBase_clickable_accessor_storage = new WeakMap(),
        _SdsTagBase_disabled_accessor_storage = new WeakMap(),
        _SdsTagBase__iconSize_accessor_storage = new WeakMap(),
        _SdsTagBase__tag_accessor_storage = new WeakMap(),
        (() => {
            var _b;
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_b = _classSuper[Symbol.metadata]) !== null && _b !== void 0 ? _b : null) : void 0;
            _name_decorators = [property({ type: String })];
            _lines_decorators = [property({ type: Number, reflect: true })];
            _status_decorators = [property({ type: String })];
            _selected_decorators = [property({ type: Boolean, reflect: true })];
            _selectable_decorators = [property({ type: Boolean })];
            _clickable_decorators = [property({ type: Boolean })];
            _disabled_decorators = [property({ type: Boolean })];
            __iconSize_decorators = [property({ type: String })];
            __tag_decorators = [query('.sds-tag')];
            _set_size_decorators = [property({
                    type: String,
                    hasChanged: (newVal) => {
                        if (!availableSizes.includes(newVal)) {
                            console.error(`Unexpected Size ${newVal}`);
                            return false;
                        }
                        else {
                            return true;
                        }
                    },
                })];
            __esDecorate(_a, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
            __esDecorate(_a, null, _lines_decorators, { kind: "accessor", name: "lines", static: false, private: false, access: { has: obj => "lines" in obj, get: obj => obj.lines, set: (obj, value) => { obj.lines = value; } }, metadata: _metadata }, _lines_initializers, _lines_extraInitializers);
            __esDecorate(_a, null, _status_decorators, { kind: "accessor", name: "status", static: false, private: false, access: { has: obj => "status" in obj, get: obj => obj.status, set: (obj, value) => { obj.status = value; } }, metadata: _metadata }, _status_initializers, _status_extraInitializers);
            __esDecorate(_a, null, _selected_decorators, { kind: "accessor", name: "selected", static: false, private: false, access: { has: obj => "selected" in obj, get: obj => obj.selected, set: (obj, value) => { obj.selected = value; } }, metadata: _metadata }, _selected_initializers, _selected_extraInitializers);
            __esDecorate(_a, null, _selectable_decorators, { kind: "accessor", name: "selectable", static: false, private: false, access: { has: obj => "selectable" in obj, get: obj => obj.selectable, set: (obj, value) => { obj.selectable = value; } }, metadata: _metadata }, _selectable_initializers, _selectable_extraInitializers);
            __esDecorate(_a, null, _clickable_decorators, { kind: "accessor", name: "clickable", static: false, private: false, access: { has: obj => "clickable" in obj, get: obj => obj.clickable, set: (obj, value) => { obj.clickable = value; } }, metadata: _metadata }, _clickable_initializers, _clickable_extraInitializers);
            __esDecorate(_a, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
            __esDecorate(_a, null, __iconSize_decorators, { kind: "accessor", name: "_iconSize", static: false, private: false, access: { has: obj => "_iconSize" in obj, get: obj => obj._iconSize, set: (obj, value) => { obj._iconSize = value; } }, metadata: _metadata }, __iconSize_initializers, __iconSize_extraInitializers);
            __esDecorate(_a, null, __tag_decorators, { kind: "accessor", name: "_tag", static: false, private: false, access: { has: obj => "_tag" in obj, get: obj => obj._tag, set: (obj, value) => { obj._tag = value; } }, metadata: _metadata }, __tag_initializers, __tag_extraInitializers);
            __esDecorate(_a, null, _set_size_decorators, { kind: "setter", name: "size", static: false, private: false, access: { has: obj => "size" in obj, set: (obj, value) => { obj.size = value; } }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(_a, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        })(),
        _a.styles = styles,
        _a;
})();
export { SdsTagBase };
